'use client';

import clsx from 'clsx';

interface Props {
	variant: 'primary' | 'secondary' | 'destructive';
}

export const Loader = ({ variant }: Props) => {
	return (
		<div className="flex items-center justify-center space-x-2">
			<style>{`
        @keyframes scaleUpDown {
          0% {
            transform: scale(1);
          }
          30% {
            transform: scale(1.8);
          }
          60% {
            transform: scale(1);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
			{[0, 1, 2].map(index => (
				<div
					key={index}
					className={clsx('h-2 w-2 rounded-full', {
						'bg-white': variant === 'primary' || variant === 'destructive'
					})}
				></div>
			))}
		</div>
	);
};
